/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rolecount1Inputs */

const en_entity_rolecount1 = /** @type {(inputs: Entity_Rolecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Count`)
};

const de_entity_rolecount1 = /** @type {(inputs: Entity_Rolecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollenanzahl`)
};

/**
* | output |
* | --- |
* | "Role Count" |
*
* @param {Entity_Rolecount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rolecount1 = /** @type {((inputs?: Entity_Rolecount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rolecount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rolecount1(inputs)
	return de_entity_rolecount1(inputs)
});
export { entity_rolecount1 as "entity_roleCount" }